import React, { useEffect, useState } from "react"

export const Test = () => {
  const [cursorType, setCursorType] = useState<string | null>(null)
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null)

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      const cursor = target.getAttribute("data-cursor")

      setCursorType(cursor)
      setPosition({ x: event.clientX, y: event.clientY })
    }

    document.addEventListener("mousemove", handleMouseMove)
    return () => document.removeEventListener("mousemove", handleMouseMove)
  }, [])

  return (
    <div className="relative flex flex-col items-center justify-center h-screen bg-gray-100 gap-8">
      <div
        className="w-64 h-32 bg-blue-500 text-white flex items-center justify-center cursor-pointer"
        data-cursor="pointer"
      >
        Наведи (pointer)
      </div>

      <div
        className="w-64 h-32 bg-green-500 text-white flex items-center justify-center"
        data-cursor="crosshair"
      >
        Наведи (crosshair)
      </div>

      <div
        className="w-64 h-32 bg-red-500 text-white flex items-center justify-center"
        data-cursor="grab"
      >
        Наведи (grab)
      </div>

      {/* Кастомный курсор */}
      {position && (
        <div
          className="fixed w-6 h-6 bg-black rounded-full"
          style={{
            top: position.y - 12,
            left: position.x - 12,
            pointerEvents: "none",
            mixBlendMode: "difference", // Интересный эффект для видимости на любом фоне
            transition: "transform 0.1s ease-out",
            cursor: cursorType || "default", // Меняем курсор
          }}
        />
      )}
    </div>
  )
}
